import { atom } from 'recoil';

export const completedActionsPage = atom({
  key: 'completedActionsPage',
  default: 1,
});
